import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { DesignBrief } from './pages/DesignBrief';
import { Prototype } from './pages/Prototype';
import { DesignSystemDisplay } from './components/DesignSystem';
import { MotionSpecsDisplay } from './components/MotionSpecs';
import { FileTextIcon, SmartphoneIcon, PaletteIcon, ZapIcon, PlayIcon, ChevronRightIcon } from 'lucide-react';
type View = 'home' | 'brief' | 'prototype' | 'design-system' | 'motion-specs';
import { VideoPlayer } from './components/VideoPlayer';
export function App() {
  return <div className="w-full h-screen bg-black" data-id="element-0">
      <VideoPlayer data-id="element-1" />
    </div>;
}
// Back button component
function BackButton({
  onClick
}: {
  onClick: () => void;
}) {
  return <motion.button onClick={onClick} className="fixed top-4 left-4 z-[100] px-4 py-2 rounded-xl bg-zinc-900/90 backdrop-blur border border-white/10 text-sm text-white hover:bg-zinc-800 transition-colors flex items-center gap-2" initial={{
    opacity: 0,
    x: -20
  }} animate={{
    opacity: 1,
    x: 0
  }} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-2">
      <ChevronRightIcon className="w-4 h-4 rotate-180" data-id="element-3" />
      Back to Home
    </motion.button>;
}